interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className = "" }: CardProps) {
  return (
    <div
      className={`bg-card rounded-lg border border-border p-6 ${className}`}
    >
      {children}
    </div>
  );
}
